'use client';

import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface SmallActionButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	prefixIcon?: IconDefinition;
	suffixIcon?: IconDefinition;
	className?: string;
	children: React.ReactNode;
}

export const SmallActionButton = ({ children, className, prefixIcon, suffixIcon, ...props }: SmallActionButtonProps) => {
	return (
		<button
			type="button"
			{...props}
			className={`flex h-[26px] w-full sm:w-auto items-center justify-center gap-1 rounded border-darkorange-100 bg-darkorange-50 px-2 py-1 text-xs font-semibold leading-[18px] text-darkorange-400 ${className}`}
		>
			{prefixIcon && <FontAwesomeIcon icon={prefixIcon} />}
			{children}
			{suffixIcon && <FontAwesomeIcon icon={suffixIcon} />}
		</button>
	);
};
